import React from "react";
import useTopic from "@livepix/components/pubsub/useTopic";
import Widget, { Props } from "../Widget";

const MarathonWidgetEmbed = (props: Props & { widgetId: string }) => {
  const [widgetProps, setWidgetProps] = React.useState<Props>(props);

  useTopic(`widget:${props.widgetId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
      case "marathon:update":
        setWidgetProps(message.payload as Props);
        break;
    }
  });

  useTopic(`user:widgets:${props.type}:${props.userId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
    }
  });

  return <Widget visible={true} {...widgetProps} />;
};

export default MarathonWidgetEmbed;
